// src/utils/sharePointLinkUtils.ts
// UX-5-F: Determine whether to open SharePoint links directly in browser vs download by file.
// Users with @fraportusa.com or @vertilocity.com open in browser; others get download.

import type { User } from '../services/authApi';

const ALLOWED_DOMAINS = ['@fraportusa.com', '@vertilocity.com'];

/**
 * Returns true if the user's email (or upn) is from a domain that can open SharePoint directly in the browser.
 * Those users get window.open(webUrl); others get file download flow.
 */
export function shouldOpenSharePointDirectly(user: User | null): boolean {
  if (!user) return false;
  const email = (user as User & { upn?: string }).email ?? (user as User & { upn?: string }).upn ?? '';
  const normalized = email.trim().toLowerCase();
  return ALLOWED_DOMAINS.some((d) => normalized.endsWith(d.toLowerCase()));
}

/**
 * Returns true if the user is internal (Fraport/Vertilocity). Internal users see "Return to Execution View";
 * external users see "Close" on action form success views.
 */
export function isInternalUser(user: User | null): boolean {
  return shouldOpenSharePointDirectly(user);
}
